import React, { useMemo } from "react";

import { determineFieldType } from "../lineItemManagement";
import { StyledPropertySelectWrapper } from "../line-item-value/styles";
import CalcIconBlue from "../../../calcIconBlue.svg";
import { FieldName, StyledFieldType } from "../styles";
import { IconWrapper, FieldLeftWrapper, NameTypeWrapper, PropertyWrapper, PropertyName, StyledChevronRight } from "./styles";

export const FieldListItem = ({ fieldProperty, setFieldSelections, setDrawerSelections }) => {
  const editField = (field) => {
    let selectedFieldType;
    if (field.isHardCoded) {
      selectedFieldType = "hard-coded";
    } else if (field.isCalculated) {
      selectedFieldType = "calculated";
    } else if (field.isFromFile) {
      selectedFieldType = "file";
    } else if (field.isFromLoanBoss) {
      selectedFieldType = "loanboss";
    } else if (field.isFromRentRoll) {
      selectedFieldType = "rentroll";
    } else {
      throw new Error("Invalid field source");
    }

    setDrawerSelections({ currentSectionName: "field-management", isEditingLineItem: true });
    setFieldSelections({ isEditing: true, selectedField: field, currentSelectedFieldType: selectedFieldType });
  };

  return (
    <>
      <FieldLeftWrapper>
        <IconWrapper>
          <img src={CalcIconBlue} alt="Calc Icon" height={24} width={24} />
        </IconWrapper>
        <NameTypeWrapper>
          <FieldName>{fieldProperty.field.name}</FieldName>
          <StyledFieldType>{`${determineFieldType(fieldProperty.field)}`}</StyledFieldType>
        </NameTypeWrapper>
      </FieldLeftWrapper>
      <PropertyWrapper onClick={() => editField(fieldProperty.field)}>
        <PropertyName>{fieldProperty.propertyName}</PropertyName>
        <StyledChevronRight />
      </PropertyWrapper>
    </>
  );
};

const UsedFieldsList = (props) => {
  const { properties, multiplePropertiesValueFields, isMultipleProperties, selectedField, setFieldSelections, setDrawerSelections, fields } = props;

  const getFieldsUsedInLineItem = (properties, isMultipleProperties, multiplePropertiesValueFields, selectedField, fields) => {
    if (!fields) {
      return [];
    }
    if (!isMultipleProperties) {
      const fieldRef = fields.find((field) => field.id === selectedField.id);
      return [{ field: fieldRef, propertyName: properties[0].name }];
    }

    const fieldsUsedInLineItem = [];
    for (const valueField of multiplePropertiesValueFields) {
      if (valueField.selectedField) {
        const fieldRef = fields.find((field) => field.id === valueField.selectedField.id);
        fieldsUsedInLineItem.push({ field: fieldRef, propertyName: valueField.propertyName });
      }
    }

    return fieldsUsedInLineItem;
  };

  const fieldsToShow = useMemo(() => getFieldsUsedInLineItem(properties, isMultipleProperties, multiplePropertiesValueFields, selectedField, fields), [fields]);


  return (
    fieldsToShow &&
    fieldsToShow.map((fieldProperty) => {
      return (
        <StyledPropertySelectWrapper key={fieldProperty.field.id}>
          <FieldListItem
            fieldProperty={fieldProperty}
            isMultipleProperties={isMultipleProperties}
            setFieldSelections={setFieldSelections}
            setDrawerSelections={setDrawerSelections}
          />
        </StyledPropertySelectWrapper>
      );
    })
  );
};

export default UsedFieldsList;
